// client/src/services/languageService.ts
import axios from 'axios';
import { API_CONFIG } from '../components/config/api';
import { isAuthenticated } from './authService';

// Unterstützte Sprachen
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch' },
  { code: 'fr', name: 'Français' },
  { code: 'es', name: 'Español' },
  { code: 'it', name: 'Italiano' },
];

// Defaultwert, falls noch nichts gespeichert ist
const DEFAULT_LANGUAGE = 'en';

/**
 * Holt die bevorzugte Sprache des Benutzers vom Server
 */
export const getUserLanguagePreference = async (): Promise<string> => {
  try {
    // Wenn der Benutzer nicht eingeloggt ist, lokale Einstellung verwenden
    if (!isAuthenticated()) {
      return getStoredLanguage();
    }
    
    const response = await axios.get(`${API_CONFIG.BASE_URL}/user/language-preference`);
    
    if (response.data.status === 'success') {
      const language = response.data.data.language;
      // Speichere auch lokal für schnelleren Zugriff
      localStorage.setItem('destiny_language', language);
      return language;
    }
    return getStoredLanguage();
  } catch (error) {
    console.error('Error fetching user language preference:', error);
    return getStoredLanguage();
  }
};

/**
 * Speichert die Spracheinstellung auf dem Server
 */
export const setUserLanguagePreference = async (language: string): Promise<boolean> => {
  try {
    // Immer lokal speichern
    localStorage.setItem('destiny_language', language);
    
    // Wenn der Benutzer nicht eingeloggt ist, keine Server-Anfrage
    if (!isAuthenticated()) {
      return true;
    }
    
    const response = await axios.post(`${API_CONFIG.BASE_URL}/user/language-preference`, {
      language
    });
    
    return response.data.status === 'success';
  } catch (error) {
    console.error('Error setting user language preference:', error);
    return false;
  }
};

/**
 * Liest die lokal gespeicherte Spracheinstellung aus
 */
export const getStoredLanguage = (): string => {
  return localStorage.getItem('destiny_language') || DEFAULT_LANGUAGE;
};

/**
 * Fügt Sprachparameter zu einer API-URL hinzu
 */
export const addLanguageToUrl = (url: string): string => {
  const language = getStoredLanguage();
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}lang=${language}`;
};